import { setupBugsink } from '@common/utils/bugsink.js';
import { config } from '@src/config/index.js';

setupBugsink({
  dsns: config.bugsinkDsns,
  version: config.version,
});

import './components/tef-coms'; // eslint-disable-line -- this line must come last
// force rebuild (FS, 27.02.2026)
